// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3TNvm","footer":"Form_footer__1srQv"};